"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pipe = void 0;
const forward_1 = require("../tools/forward");
var Pipe;
(function (Pipe) {
    Pipe.skipIf = (f, pred) => (arg) => pred(arg) ? f(arg) : arg;
    Pipe.discard = (f) => (arg) => (0, forward_1.forward)(f(arg), () => arg);
})(Pipe = exports.Pipe || (exports.Pipe = {}));
//# sourceMappingURL=Pipe.js.map